import {Loanslist} from "./loanslist";

export class LoansRejected extends Loanslist {
  filter = {rejected: "EQ,true,AND"};

}
